

















import { Component, Mixins } from 'vue-property-decorator'

import DeviceWidthCheckerMixin from '@/mixins/deviceWidthChecker.mixin'
import HeaderComponent from '@/ui-components/header/HeaderComponent.vue'
import FooterComponent from '@/ui-components/footer/FooterComponent'
import SessionUnavailableAlert from '@/popupcomponents/sessionUnavailableAlert/SessionUnavailableAlert.vue'
import cart from '@/store/modules/checkout/cart/module'
import { CartItem } from '@/Model/checkout/cart/types'

@Component({
  components: {
    HeaderComponent,
    FooterComponent,
    SessionUnavailableAlert
  }
})
export default class Checkout extends Mixins(DeviceWidthCheckerMixin) {
  get isFetchingCart(): boolean {
    return cart.isInitializingCart || cart.isFetchingCart
  }

  get showGenericUnavailableAlert(): boolean {
    return cart.invalidItemsRemoved
  }

  get firstValidationItemSet(): CartItem[] {
    return cart.invalidCartItems[0] ? cart.invalidCartItems[0].items : []
  }
}
